import { render, staticRenderFns } from "./BaseNotification.vue?vue&type=template&id=57c214c5&"
import script from "./BaseNotification.vue?vue&type=script&lang=js&"
export * from "./BaseNotification.vue?vue&type=script&lang=js&"
import style0 from "./BaseNotification.vue?vue&type=style&index=0&id=57c214c5&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ichigei/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57c214c5')) {
      api.createRecord('57c214c5', component.options)
    } else {
      api.reload('57c214c5', component.options)
    }
    module.hot.accept("./BaseNotification.vue?vue&type=template&id=57c214c5&", function () {
      api.rerender('57c214c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Notification/BaseNotification.vue"
export default component.exports